// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import {
  FilterItem as StyledFilterItem,
  CloseButton
} from "src/components/Manage/Workflow/Instances/styles";
import * as colors from "src/styles/constants/colors";
import { formColumnNames } from "src/constants/display";
import NameOrEmail from "src/containers/user/NameOrEmail";
import Icon from "src/icons";

type Props = {
  uid: any,
  column: string,
  handleClose: Function
};

const User = ({ uid, column, handleClose }: Props) => {
  return (
    <StyledFilterItem>
      <span>
        {formColumnNames[column]}
        {i18n.t(k._)}
      </span>
      <strong>
        <NameOrEmail uid={uid} />
      </strong>
      <CloseButton onClick={handleClose}>
        <Icon type="close" color={colors.active} />
      </CloseButton>
    </StyledFilterItem>
  );
};

export default User;
